import { render, staticRenderFns } from "./FileBrowserFolder.vue?vue&type=template&id=9b45139a&scoped=true&lang=html"
import script from "./FileBrowserFolder.vue?vue&type=script&lang=js"
export * from "./FileBrowserFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b45139a",
  null
  
)

export default component.exports